"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const GridColumnDataDisplayedType_1 = require("../GridColumnDataDisplayedType");
class BooleanRenderer {
    canRender(o) {
        return typeof o === "boolean" || o instanceof Boolean;
    }
    render(ctx, aBoolean) {
        ctx.html(`${aBoolean}`);
        ctx.setColumnDataDisplayType(GridColumnDataDisplayedType_1.GridColumnDataDisplayedType.BOOLEAN);
    }
}
exports.default = BooleanRenderer;
//# sourceMappingURL=BooleanRenderer.js.map